/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SpecialityModel } from '../../models/speciality-model';

export interface AnonymousSpecialityIdGet$Params {
  id: string;
}

export function anonymousSpecialityIdGet(http: HttpClient, rootUrl: string, params: AnonymousSpecialityIdGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<SpecialityModel>> {
  const rb = new RequestBuilder(rootUrl, anonymousSpecialityIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<SpecialityModel>;
    })
  );
}

anonymousSpecialityIdGet.PATH = '/Anonymous/Speciality/{id}';
